import axios from 'axios';

const AuthApi = (apiUrl, apiAccessToken) =>
  axios.create({
    baseURL: `${apiUrl}/customers/auth`,
    headers: {
      'X-Access-Token': apiAccessToken
    }
  });

export default AuthApi;
